<div class="bg-white border-2 border-accent/10 rounded-[6px] shadow-sm overflow-hidden">
  <slot />
</div>